import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { ApplicantState } from "../types";

const getters: GetterTree<ApplicantState, RootState> = {
  allApplicants: (state) => state.applicants,
  allApplicantAudits: (state) => state.audits,
  hasNextPage: (state) => state.applicants.hasNextPage,
  hasPreviousPage: (state) => state.applicants.hasPreviousPage,
  allApprovedApplicants: (state) => state.allApprovedApplicants,
  allRejectedApplicants: (state) => state.allRejectedApplicants,
  allPendingApplicants: (state) => state.allPendingApplicants,
  currentApplicant: (state) => state.currentApplicant,
  isViewing: (state) => state.isViewing,
  isAllApplicantsEmpty: (state) => state.applicants.items.length === 0,
  isAllApplicantAuditEmpty: (state) => state.audits.items.length === 0,
  isApprovedApplicantsEmpty: (state) =>
    state.allApprovedApplicants.items.length === 0,
  isRejectedApplicantsEmpty: (state) =>
    state.allRejectedApplicants.items.length === 0,
  isPendingApplicantsEmpty: (state) =>
    state.allPendingApplicants.items.length === 0,
  sortOrder: (state) => state.sortOrder,
  sortBy: (state) => state.sortBy,
  isFetchingApplicants: (state) => state.isFetchingApplicants,
  isLoadingCurrentApplicant: (state) => state.isLoadingCurrentApplicant,
  query: (state) => state.query,
};

export default getters;
